export enum UserBlock {
  UNSET = "UNSET",
  OUT_OF_BOUNDS = "OUT_OF_BOUNDS",
}

export enum SidebarState {
  EXPANDED,
  COLLAPSED,
}